import { render, staticRenderFns } from "./DataActions.vue?vue&type=template&id=6187ea73&"
import script from "./DataActions.vue?vue&type=script&lang=js&"
export * from "./DataActions.vue?vue&type=script&lang=js&"
import style0 from "./DataActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6187ea73')) {
      api.createRecord('6187ea73', component.options)
    } else {
      api.reload('6187ea73', component.options)
    }
    module.hot.accept("./DataActions.vue?vue&type=template&id=6187ea73&", function () {
      api.rerender('6187ea73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataActions.vue"
export default component.exports